<template>
  <div class="ecommerce-application">
    <checkout-success />
  </div>
</template>

<script>
import CheckoutSuccess from './apps/e-commerce/e-commerce-checkout/ECommerceCheckoutSuccess.vue'

export default {
  components: {
    CheckoutSuccess,
  },
}
</script>
